'use client';

import './sider-left.scss';
import { useContentSize } from "@/components/SizeProvider";
import { getBodyFontSize } from "@/lib/utils/typography";
import { getSiderSize } from "@/lib/utils/desktopGeometry";
import Intro from "./Intro";
import LoadingCapabilities from "./LoadingCapabilities"
import Processing from "./Processing";

const SiderLeft = () => {
  const { width: widthContent, height: heightContent } = useContentSize();
  const siderSize = getSiderSize(widthContent, heightContent);
  return (
    <div className={'sider-left'} style={{
      width: siderSize.width,
      fontSize: getBodyFontSize(widthContent, { ceil: false }),
      height: siderSize.height,
    }}>
      <Intro />
      <LoadingCapabilities/>
      <Processing/>
    </div>
  )
};

export default SiderLeft;
